import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { Container } from 'chaoskit/src/components'

import Image from '~components/Image'
import { shadowEmboss } from '~styles/utility'
import pattern from '~media/home/intro-pattern.svg'
import gremlin from '~media/home/intro-gremlin.svg'

export const IntroBoxUI = ({
  children,
  showTexture,
  showGremlin,
  shadowDirection = 'right',
  ...props
}) => {
  const theme = useTheme()

  const gremlinHeight = 50
  const patternDimensions = {
    width: 500,
    height: 400,
  }

  return (
    <Container {...props}>
      <aside
        css={[
          {
            position: 'relative',
            zIndex: 1,
            marginTop: -theme.space.large,

            [theme.mq.medium]: {
              marginTop: -theme.space.xlarge,
            },
          },

          showTexture && {
            '&::before': {
              content: "''",
              zIndex: 0,
              background: `url(${pattern}) no-repeat center center`,
              width: patternDimensions.width / 1.5,
              height: patternDimensions.height / 1.5,
              backgroundSize: 'contain',
              top: 0,
              left: 0,
              transform: 'translateX(-35%)',
              position: 'absolute',

              [theme.mq.medium]: {
                width: patternDimensions.width,
                height: patternDimensions.height,
              },
            },
          },
        ]}
      >
        <div
          className="IntroBox__Inner"
          css={[
            shadowEmboss(theme, {
              size: '20px',
              direction: shadowDirection,
            }),
            {
              borderRadius: theme.borderRadius.base,
              background: theme.color.light.base,
              textAlign: 'center',
              padding: theme.space.base,
              position: 'relative',
              zIndex: 1,

              [theme.mq.medium]: {
                padding: theme.space.large,
              },
            },
          ]}
        >
          {showGremlin && (
            <Image
              css={{
                height: gremlinHeight,
                position: 'absolute',
                top: -gremlinHeight + 12, // Offset for illustration placement only
                right: theme.space.xlarge,
              }}
              src={gremlin}
              alt=""
            />
          )}

          {children}
        </div>
      </aside>
    </Container>
  )
}

IntroBoxUI.propTypes = {
  children: PropTypes.node.isRequired,
  showTexture: PropTypes.bool,
  showGremlin: PropTypes.bool,
  shadowDirection: PropTypes.oneOf(['left', 'right']),
}
